import { render, staticRenderFns } from "./ContactUserLoans.vue?vue&type=template&id=81a2a8a6"
import script from "./ContactUserLoans.vue?vue&type=script&lang=js"
export * from "./ContactUserLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports